<template>
    <div>
        <template v-if="!hidePort">
            <div class="col-md-12" id="widget-main-tripup"
                 v-bind:data-customer=customerId
                 v-bind:data-coupon=couponCode
                 v-bind:data-channel=channel
                 v-bind:data-components=components
                 v-bind:data-tags=tags
                 v-bind:data-limit=limit
                 v-bind:data-destination=destination
                 v-bind:data-ship=cruiseShipName
                 v-bind:data-date=cruiseDate
                 v-bind:data-duration=cruiseDuration
                 v-bind:data-port_id=portId
                 v-bind:data-shortproducts=shortProducts
                 v-bind:data-showtitles=showTitles
                 v-bind:data-cruisetype=cruiseType
                 data-showport="true"
            ></div>
        </template>
        <template v-if="hidePort">
            <div class="col-md-12" id="widget-main-tripup"
                 v-bind:data-customer=customerId
                 v-bind:data-coupon=couponCode
                 v-bind:data-channel=channel
                 v-bind:data-components=components
                 v-bind:data-tags=tags
                 v-bind:data-limit=limit
                 v-bind:data-destination=destination
                 v-bind:data-ship=cruiseShipName
                 v-bind:data-date=cruiseDate
                 v-bind:data-duration=cruiseDuration
                 v-bind:data-port_id=portId
                 v-bind:data-shortproducts=shortProducts
                 v-bind:data-showtitles=showTitles
                 v-bind:data-cruisetype=cruiseType
                 data-showport="false"
            ></div>
        </template>
    </div>
</template>

<script>
import LangService from '../services/LangService';

export default {
  name: "Preview",
  props: [
    'customerId', 'shopSelected', 'couponCode', 'channel', 'components', 'cruiseShipName', 'cruiseDate', 'cruiseDuration', 'portId', 'shortProducts', 'showTitles',
    'tags', 'limit', 'destination', 'hidePort', 'cruiseType'
  ],
  mounted() {
    var elemWidgetScript = document.getElementById('widget-script');

    if (elemWidgetScript) {
      elemWidgetScript.remove();
            }
            var elemWidgetMainTripUp = document.getElementById('widget-main-tripup-tripup');
            if (elemWidgetMainTripUp) {
                elemWidgetMainTripUp.remove();
            }
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', LangService.getUrlWidget() + '/itinerary/js/main.min.js');
            recaptchaScript.id = "widget-script";
            recaptchaScript.setAttribute('data-containers', "widget-main-tripup, widget-search-tripup");
            document.head.appendChild(recaptchaScript);
        }
    }

</script>
